import assert from 'assert'

export const COLUMNS = 4

// Because we half the number of column on tiny breakpoint:
assert(COLUMNS % 2 === 0, 'Number of columns in the slider must be even')
// Because we use l-col--X-of-12 classes
assert(
  12 % COLUMNS === 0,
  'Number of columns in our grid (12) must be dividable by number of columns in the slider without the remainder'
)

// Range of widths images in the slider can be rendered on (determined
// empirically) given COLUMNS.
export const IMAGE_MIN_WIDTH = 135
export const IMAGE_MAX_WIDTH = 281
